<template>
    <drop style=" height: 12px; width: 100%; " @dragover="dragOver" @dragleave="dragLeave" @drop="dragLeave"></drop>
</template>

<script>
import { Drag, Drop } from 'vue-drag-drop'

export default {
    name: 'scrollhelper',
    components: {Drag, Drop},
    props: {
        dir: {
            type: Number,
            default: 1
            }
        },
    data: function(){
        return {
            counter: 0,
            ii: null
        }
    },

    methods: {
        dragOver: function(){
            var self = this
            function scrollIt(){
                //if(document.getElementById('listsHolder').scrollY > 0){
                    document.getElementById('listsHolder').scrollBy(0, 5 * self.dir)
                //}
                
            }
            if(this.counter == 0){
                 this.ii = setInterval(scrollIt, 10 )
            }
            this.counter++
        },

        dragLeave: function(){
            window.clearInterval(this.ii)
            this.counter = 0;
        }
    }

    
}


</script>